import {StaticPage} from "components/static-page"
import {FC} from "react"
import cx from "classnames"
import {CheckIcon} from "@heroicons/react/outline"

const PrivacyPolicy: FC<{}> = (props) => {
  const app = "FocusTask"

  return (
    <StaticPage title="Pricing">
      <p className="text-zinc-400">
        FocusTask isn't feature complete just yet, so we decided to offer it at
        a great price for our early customers.
      </p>

      <p className="text-zinc-400">
        You'll be locked into this plan, so your price won't increase when we
        launch!
      </p>

      <div
        className={cx(
          "grid grid-cols-2",
          "rounded",
          "overflow-hidden",
          "shadow-sm",
          "border border-zinc-100 dark:border-zinc-800",
          "bg-white dark:bg-zinc-900",
        )}
      >
        <div
          className={cx("p-4", "border-b border-zinc-100 dark:border-zinc-800")}
        >
          Early bird
        </div>
        <div
          className={cx("p-4", "border-b border-zinc-100 dark:border-zinc-800")}
        >
          <strong>30€/year</strong>
        </div>
        <div className={cx("p-4")}>Regular</div>
        <div className={cx("p-4")}>
          <strong>5€/mo</strong>
        </div>
      </div>

      <h2 className={cx("font-heading", "text-2xl", "font-medium")}>
        Included features
      </h2>

      <p className="text-zinc-400">
        FocusTask already offers a lot! You can use all of these right now:
      </p>

      <div className={cx("grid grid-cols-2 gap-2")}>
        {[
          "Web application",
          "Kanban board",
          "Snoozing/Planning",
          "Calendar integration",
          "Custom views",
        ].map((feature) => (
          <div
            className={cx(
              "p-4",
              "rounded",
              "border border-zinc-100 dark:border-zinc-800",
              "bg-white dark:bg-zinc-900",
              "rounded",
              "shadow-sm",
              "flex",
            )}
          >
            <span>{feature}</span>

            <span className="flex-1" />

            <CheckIcon width={18} className="text-blue-500" />
          </div>
        ))}
      </div>

      <h2 className={cx("font-heading", "text-2xl", "font-medium")}>
        Upcoming features
      </h2>

      <p className="text-zinc-400">
        All features will be included in your early bird membership. Storing
        large files might be subject to additional fees.
      </p>

      <div className={cx("grid grid-cols-2 gap-2")}>
        {[
          "Mobile app",
          "Mac/Windows app",
          "Repeating tasks",
          "Subtasks",
          "File attachments",
          "E-mail integration",
        ].map((feature) => (
          <div
            className={cx(
              "p-4",
              "rounded",
              "border border-zinc-100 dark:border-zinc-800",
              "bg-white dark:bg-zinc-900",
              "rounded",
              "shadow-sm",
              "flex",
            )}
          >
            {feature}

            <span className="flex-1" />

            {feature === "Mobile app" ? (
              <span className="text-sm font-semibold text-blue-500">WIP</span>
            ) : null}
          </div>
        ))}
      </div>
    </StaticPage>
  )
}

export default PrivacyPolicy
